
import ToolkitProvider, {
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import { BlockPicker } from "react-color";
import Select from "react-select";
import makeAnimated from "react-select/animated";

import ConfirmAddProduct from "../../ui/ConfirmAddProduct";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@mui/material";
import "./AddProductStyle.css";
import SpecificityService from "../../services/SpecificityService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ProductService from "../../services/ProductService";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const AddSpecificityToCompletedProduct = () => {
  const navigate = useNavigate();

 
  const [libelleColor, setLibelleColor] = useState("");
  const [descriptionSpecificity, setDescriptionSpecificity] = useState("");

  const [background, setBackground] = useState("#FF5733");
  const [specificities, setSpecificities] = useState([]);

  const [productName, setProductName] = useState("");
  const [onConfirmAddProduct, setOnConfirmAddProduct] = useState(false);
  const [confirmProductModel, setConfirmProductModel] = useState();
  const [availableSpecificity, setAvailableSpecificity] = useState([]);
  const [specifityChoosen, setSpecifityChoosen] = useState([]);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [specificitySelectPlaceHolder, setSpecificitySelectPlaceHolder] =
    useState("Choisir une spécificité produits");
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [selectedOption, setSelectedOption] = useState(null);

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("Choisir une image");
  const [fileDataURL, setFileDataURL] = useState(null);
  const [myProductModel, setMyProductModel] = useState({});
  const [product, setProduct] = useState();
  const [typeSpecificity, setTypeSpecificity] = useState("");
  const [specificityTableData, setSpecificityTableData] = useState([]);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  // const [specificitiesTableData, setSpecificitiesTableData] = useState([]);

  const animatedComponents = makeAnimated();
  useEffect(() => {
    ProductService.getProductById(
      getCurrentUserId(),
      sessionStorage.getItem("idProduct")
    ).then((response) => {
      setProduct(response.data["Product"]);
      setSpecificityTableData(response.data["Product"].specificities)
      SpecificityService.getProductSpecificityByCategory(
        getCurrentUserId(),
        response.data["Product"].category.id
      ).then((responseSpecificite) => {
        setAvailableSpecificity(responseSpecificite.data);
      });
    });

    // dispatch(getAllFamilies(0));
    // dispatch(getAllBrands(0));
  }, []);
  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };

  useEffect(() => {
    let fileReader,
      isCancel = false;
    if (file) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const { result } = e.target;
        if (result && !isCancel) {
          setFileDataURL(result);
        }
      };
      fileReader.readAsDataURL(file);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };
  }, [file]);


  useEffect(() => {
    setSpecificities([]);

    availableSpecificity &&
      availableSpecificity.map((element, i) => {
        setSpecificities((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            customElements: element.type,
          },
        ]);
      });
  }, [availableSpecificity]);

 

  const onChangeNameHandler = (event) => {
    setProductName(event.target.value);
  };
  const onChangeValueHandler = (event) => {
    setBackground(event.target.value);
  };
  const handleChangeComplete = (color, event) => {
    setBackground(color.hex);
  };
  const changeLibelleSpecificityHandler = (event) => {
    setLibelleColor(event.target.value);
  };
  const changeDescriptionSpecificityHandler = (event) => {
    setDescriptionSpecificity(event.target.value);
  };

  const onUploadImageHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      const file = e.target.files[0];

      setFile(file);
      setFileName(e.target.files[0].name);
    }
  };



  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const onChangeSelected = (selectedOption) => {
    setSelectedOption();
    setSpecifityChoosen(selectedOption.value);
    setSpecificitySelectPlaceHolder(selectedOption.label);
    setTypeSpecificity(selectedOption.customElements);
  };
  const onAddSpecificityToList = (event) => {
    let productSpecificityRef = null;

    let exist = false;
    let idSpecificity = null;
    let indexInDataTable;

    if (specifityChoosen === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Sélectionnez un produit ");
    } else {
      try {
        specificityTableData.forEach((element, index) => {
          console.log("element", element);
          if (element.idProductSpecificity === specifityChoosen) {
            indexInDataTable = index;
            productSpecificityRef = element.idProductSpecificity;
            exist = true;
            console.log("specifityById indexInDataTable", indexInDataTable);
            throw "Break";
          }
        });
      } catch (e) {
        if (e !== "Break") throw e;
      }
      if (!exist) {
     
      setSpecificityTableData((previoustate) => [
        ...previoustate,
        {
          name: libelleColor,
          idProductSpecificity: specifityChoosen,
          value: background,
          description: descriptionSpecificity,
          type: typeSpecificity,
        },
      ]);
    }else if(exist){
      let specificityUpdateValue = specificityTableData[indexInDataTable];
      specificityUpdateValue.name=libelleColor;
      specificityUpdateValue.description=descriptionSpecificity;
      specificityUpdateValue.value=background;

      setOpenInfoAlert(true);
      setInfoAlertText(
        "Info : Vous avez actualisé la spécificité  :  " + specificityUpdateValue.name
      );


    }
  }
  };
  const onConfirmAddProductMarketingHandler = (event) => {
    let productModel = {
      idProduct: product.id,

      idUserCreation: getCurrentUserId(),
      specificities: specificityTableData,
    };
    // console.log(JSON.stringify(productModel));
    ProductService.addSpecificity2Product(productModel).then(
      (resultMerketing) => {
        if (resultMerketing.data["success"]) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Ajout avec succées");
          setTimeout(() => {
            navigate(`/products`);
          }, 2000);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :erreur serveur ");
        }
      }
    );
  };
  const blocSpecificity = () => {
    if (typeSpecificity === 1) {
      return (
        <div className="row">
          <div className="col-md-4">
            <label>Libellé:</label>
            <input
              type="libelle"
              className="form-control"
              placeholder="Ajouter libellé"
              value={libelleColor}
              onChange={changeLibelleSpecificityHandler}
            />
          </div>
          <div className="col-md-4">
            {" "}
            <label>Description:</label>
            <input
              type="description"
              className="form-control"
              placeholder="Ajouter description"
              value={descriptionSpecificity}
              onChange={changeDescriptionSpecificityHandler}
            />
          </div>

          <div className="col-md-4">
            <label>Choisir la couleur : </label>
            <BlockPicker
              color={background}
              onChangeComplete={handleChangeComplete}
            />
          </div>
          <div className="form-group" class="col-sm-4 ">
            <button
              style={{ marginTop: 20, marginBottom: 20 }}
              class="btn btn-dark  float-right"
              onClick={onAddSpecificityToList}
            >
              <i class="fas fa-plus"></i>
              Liste des spécificitées{" "}
            </button>
          </div>
        </div>
      );
    } else if (typeSpecificity === 0) {
      return (
        <div className="row">
          <div className="col-md-4">
            <label>Libellé:</label>
            <input
              type="libelle"
              className="form-control"
              placeholder="Ajouter libellé"
              value={libelleColor}
              onChange={changeLibelleSpecificityHandler}
            />
          </div>
          <div className="col-md-4">
            {" "}
            <label>Description:</label>
            <input
              type="description"
              className="form-control"
              placeholder="Ajouter Description"
              value={descriptionSpecificity}
              onChange={changeDescriptionSpecificityHandler}
            />
          </div>
          <div className="col-md-4">
            {" "}
            <label>Valeur:</label>
            <input
              type="valeur"
              className="form-control"
              placeholder="Ajouter libellé"
              value={background}
              onChange={onChangeValueHandler}
            />
          </div>

          <div className="form-group" class="col-sm-4 ">
            <button
              style={{ marginTop: 20, marginBottom: 20 }}
              class="btn btn-dark  float-right"
              onClick={onAddSpecificityToList}
            >
              <i class="fas fa-plus"></i>
              Liste des spécificitées{" "}
            </button>
          </div>
        </div>
      );
    }
  };

  const columns = [
    {
      dataField: "name",
      text: "Libellé ",
    },
    {
      dataField: "value",
      text: "Valeur",
    },
    {
      dataField: "description",
      text: "Description",
    },
    {
      dataField: "idProductSpecificity",
      text: "SUP",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("specificitiesTableData", specificityTableData);

          setSpecificityTableData(
            specificityTableData.filter((item) => item.idProductSpecificity !== row.idProductSpecificity)
          );
        },
      },
    },
  ];
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  function handleTableChange({ specificitiesTableData }) {
    return specificitiesTableData;
  }
  const specificitiesList = (product) => {
    if (product.specificities.length > 0) {
      // <table
        //   class="table table-striped table-bordered table-sm"
        //   cellspacing="0"
        //   width="100%"
        // >
        //   <thead>
        //     <tr className="text-center">
        //       <th>Libellé</th>
        //       <th>Valeur</th>
        //       <th>Description</th>
        //     </tr>
        //   </thead>
        //   <tbody>
        //     {row.specificities &&
        //       row.specificities.map((element, i) => (
        //         <tr key={i}>
        //           <td>{element.name}</td>

        //           <td>{element.value}</td>

        //           <td className="text-center">{element.description}</td>
        //         </tr>
        //       ))}
        //   </tbody>
        // </table>
      return (
       <>
        {specificityTableData && (
          <ToolkitProvider
            keyField="idProductSpecificity"
            data={specificityTableData}
            columns={columns}
            onTableChange={handleTableChange}
          >
            {(props) => (
              <div>
                <div className="row">
                  <BootstrapTable
                    {...props.baseProps}
                    striped
                    hover
                    condensed
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        )}</> 
      );
    }
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter des spécificités</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      {product && (
        <section className="content ">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card card-dark">
                  <div className="card-header">
                    <h5 className="card-title">
                      Compléter le produit {product.name}
                    </h5>
                  </div>
                  

                  <div className="card-body">
                  <div class="row">
                  <label>Les spécificités</label>
                  {/* {specificitiesList(product)} */}
                  </div>
                    <div class="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>Choisir une spécificité</label>
                          <Select
                            styles={styles}
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            defaultValue={selectedOption}
                            onChange={onChangeSelected}
                            options={specificities}
                            placeholder={specificitySelectPlaceHolder}
                            menuPlacement={"top"}
                          />
                        </div>
                      </div>
                    </div>
                    {blocSpecificity()}
                    {specificityTableData && (
                      <ToolkitProvider
                        keyField="id"
                        data={specificityTableData}
                        columns={columns}
                      >
                        {(props) => (
                          <div>
                            <div className="row">
                              <BootstrapTable
                                {...props.baseProps}
                                striped
                                hover
                                condensed
                              />
                            </div>
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </div>

                  <div class="card-footer">
                    <button
                      class="btn btn-dark float-right"
                      onClick={onConfirmAddProductMarketingHandler}
                    >
                      Confirmer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      <div class="col-sm-10"> </div>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="error">
          {infoAlertText}
        </Alert>
      </Snackbar>
      {/* {onAddSubFamily && (
        <AddSubFamily
          familyId={familyId}
          setOnAddSubFamily={setOnAddSubFamily}
        />
      )} */}
      {/* {onAddFamily && <AddFamily setOnAddFamily={setOnAddFamily} />} */}
      {/* {onAddBrand && <AddBrand setOnAddBrand={setOnAddBrand} />} */}
      {/* {onAddCategory && (
        <AddCategory
          familyId={familyId}
          subFamilyId={subFamilyId}
          setOnAddCategory={setOnAddCategory}
        />
      )} */}
      {onConfirmAddProduct && (
        <ConfirmAddProduct
          setOnConfirmAddProduct={setOnConfirmAddProduct}
          confirmProductModel={confirmProductModel}
          setMyProductModel={setMyProductModel}
        />
      )}
    </div>
  );
};
export default AddSpecificityToCompletedProduct;
